import {
  StyleSheet,
  FlatList,
  View,
  SafeAreaView,
  Text,
  Pressable,
  ScrollView,
} from "react-native";
import HighlightedDiscountsRail from "../../../components/HighlightedDiscountsRail";
import React, { useEffect, useState } from "react";
import DiscountsForYouRail from "../../../components/DiscountsForYouRail";
import FoodDiscountsRail from "../../../components/FoodDiscountsRail";
import AllDiscounts from "./AllDiscounts";
import useApi from "../../../hooks/useAPI";
import { useQuery } from "react-query";
import { useTheme, Menu, Button, Divider, Provider } from "react-native-paper";
import { Entypo } from "@expo/vector-icons";
import { categoriesFilter } from "./FilterBar";
import { Filters } from "./FilterBar";

interface FilterOption {
  name: string;
  subCategories: string[];
  type: categoriesFilter;
}
const DropdownButton = ({
  item,
  selectedCategory,
  setSelectedCategory,
  setSelectedFilter,
  selectedFilters,
}: {
  item: FilterOption;
  selectedCategory: string;
  setSelectedCategory: (name: string) => void;
  setSelectedFilter: (category: string, option: string) => void;
  selectedFilters: Filters;
}) => {
  const { name, subCategories } = item;
  const { colors } = useTheme();
  const [visible, setVisible] = useState(false);
  const openMenu = () => setVisible(true);
  const closeMenu = () => setVisible(false);
  //   console.log(selectedCategory);

  function checkFilter(categoriesFilter: string) {
    if (categoriesFilter === "isicType" && selectedFilters.isicType === "Todas")
      return "Carteira";
    else if (
      categoriesFilter === "isicType" &&
      selectedFilters.isicType != "Todas" &&
      selectedFilters.isicType != "Todas"
    )
      return selectedFilters.isicType.split(" ").pop();
    else if (
      categoriesFilter === "region" &&
      selectedFilters.region === "Todas"
    )
      return "Região";
    else if (
      selectedFilters.region != "Todas" &&
      categoriesFilter === "region"
    ) {
      return selectedFilters.region;
    } else if (
      categoriesFilter === "storeType" &&
      selectedFilters.storeType === "Todas"
    ) {
      return "Tipo de loja";
    } else if (
      categoriesFilter === "storeType" &&
      selectedFilters.storeType != "Todas"
    ) {
      return selectedFilters.storeType;
    }else if(
      categoriesFilter === "category"
      && selectedFilters.category === "Todas"
    ){
      return "Categoria"
    }else if(
      categoriesFilter === "category"
      && selectedFilters.category != "Todas"
    ){
      return selectedFilters.category
    }
  }
  function checkIfShouldRenderAll(filter: string) {
    console.log(filter);
    if (filter === "Mostrar todos os descontos" || "Todos") return "Todas";
    return filter;
  }
  return (
    <Menu
      visible={visible}
      onDismiss={closeMenu}
      style={{ borderRadius: 50 }}
      contentStyle={{
        marginTop: 22,
        borderRadius: 20,
        backgroundColor: "#fff",
        alignItems: "center",
      }}
      anchor={
        <Pressable
          onPress={() => {
            setSelectedCategory(name);
            openMenu();
          }}
          style={[
            styles.item,
            {
              marginLeft: 0,
              backgroundColor:
                selectedCategory === item.name
                  ? colors.pureWhite
                  : colors.figmaBackgroundColor,
              borderWidth: 1,
              borderColor:
                selectedCategory === item.name
                  ? colors.figmaBackgroundColor
                  : colors.pureWhite,
            },
          ]}
        >
          <Text
            style={[
              styles.itemName,
              {
                color:
                  selectedCategory === item.name
                    ? colors.figmaBackgroundColor
                    : colors.pureWhite,
              },
            ]}
          >
            {checkFilter(item.type)}
          </Text>
          <Entypo
            style={{ marginLeft: 8 }}
            name="chevron-thin-down"
            size={13.5}
            color={
              selectedCategory === item.name
                ? colors.figmaBackgroundColor
                : colors.pureWhite
            }
          />
        </Pressable>
      }
    >
      {subCategories.map((category, j) => {
        return (
          <Pressable onPress={() => {}}>
            <Menu.Item
              key={j}
              onPress={() => {
                setSelectedFilter(item.type, category);
              }}
              title={category}
              titleStyle={{
                fontFamily: "DmSans",
                alignSelf: "center",
              }}
            />
            <Divider />
          </Pressable>
        );
      })}
    </Menu>
  );
};
export default DropdownButton;
const styles = StyleSheet.create({
  root: { flex: 1, zIndex: 5 },
  container: { zIndex: 1 },

  filter: {
    height: 62,
    //height: "100%",
    //flex: 1,
    paddingBottom: 20,
    //backgroundColor: "#0f0",
    //overflow: "visible",
    // position: "absolute",
    // elevation: 20,
    // zIndex: 20,
    // top: 160,
  },
  itemName: {
    color: "#00f",
    fontFamily: "DmSans",
  },
  item: {
    height: 37,
    //flex: 1,
    marginHorizontal: 10,
    paddingHorizontal: 20,
    alignItems: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
    borderRadius: 25,
    flexDirection: "row",
    zIndex: 5,
    //overflow: "visible",
  },
  menu: {
    position: "absolute",
    top: 38,
    left: 0,
    zIndex: 9,
    height: 60,
    width: 370,
    backgroundColor: "red",
    elevation: 10,
    //flex: 1,
    borderRadius: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.5,
    shadowRadius: 2,
  },
});
